import { useState } from 'react';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import request from '../../utils/APIHelper/request';
import { branchOptions } from '../../constants/enums/RefundContacts';
import Select from 'react-select';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import { toast } from 'react-toastify';

// Custom styles for react-select
const customSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure the menu appears above other elements
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure the portal has a high z-index
  }),
  menuList: (provided) => ({
    ...provided,
  }),
};

const ParcelRatesCreatingWindow = ({ navigate, updateFilter = () => {} }) => {
  const [branch, setBranch] = useState();
  const [agentsForSearch, setAgentsForSearch] = useState();
  const [agentFrom, setAgentFrom] = useState();
  const [agentTo, setAgentTo] = useState();
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [copyingLoading, setCopyingLoading] = useState();
  const [messageLoading, setMessageLoading] = useState();
  const [availableRatesAmount, setAvailableRatesAmount] = useState(0);

  const changeBranch = async (selectedBranch) => {
    if (selectedBranch) {
      setBranch(selectedBranch);
      const result = await request({
        url: `${controllers.agent}getAgentsByBranch`,
        type: requestTypes.post,
        params: { branchId: selectedBranch.value },
      });
      const agents = result?.map((a) => ({ value: a, label: a }));
      setAgentsForSearch(agents);
    } else {
      setAgentsForSearch([]);
    }
    setAgentFrom(null);
    setAgentTo(null);
    setBranch(selectedBranch);
  };

  const saveable = () => {
    return branch && agentFrom && agentTo;
  };

  const showWarning = () => {
    return saveable();
  };

  const checkRates = async (branchId, agentCode, agentCode2) => {
    if (agentCode && agentCode2) {
      const result = await request({
        url: `${controllers.parcelRates}checkBeforeCopyingRates`,
        type: requestTypes.post,
        params: {
          branch: branchId,
          agentCode,
          agentCode2,
        },
        setLoading: setMessageLoading,
      });
      setMessage(result?.message);
      setMessageType(result?.code);
      setAvailableRatesAmount(result?.result);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const copyRates = async (branchId, agentCode, agentCode2) => {
    if (agentCode && agentCode2) {
      const result = await request({
        url: `${controllers.parcelRates}CopyActiveRatesFromAgentToAgent`,
        type: requestTypes.post,
        params: {
          branch: branchId,
          agentCode,
          agentCode2,
        },
        setLoading: setCopyingLoading,
      });
      if (result?.code === responseTypes.success) {
        toast.success(result?.message);
        navigate(`/parcelRates?agent=${agentCode2}&status=Active`);
        updateFilter(agentCode2);
        Swal.close();
      }
    }
  };

  const displayMessageType = (type) => {
    switch (type) {
      case responseTypes.success:
        return (
          <div>
            <div className="font-semibold text-green-700">
              {'Action allowed'}
              <div className="w-1/2 h-[1px] bg-green-700 mx-auto my-1"></div>
            </div>
          </div>
        );
      case responseTypes.error:
      case responseTypes.warning:
        return (
          <div>
            <div className="font-semibold text-red-700">{'Attention!'}</div>
            <div className="w-1/2 h-[1px] bg-red-700 mx-auto my-1"></div>
          </div>
        );
      default:
        return (
          <div>
            <div className="font-semibold text-gray-400">{'Message:'}</div>
            <div className="w-1/2 h-[1px] bg-gray-400 mx-auto my-1"></div>
          </div>
        );
    }
  };

  const getMessageColor = (type) => {
    switch (type) {
      case responseTypes.success:
        return 'text-green-700';
      case responseTypes.warning:
        return 'text-orange-600';
      default:
        return 'text-gray-700';
    }
  };

  return (
    <div>
      <div className="inline-block mx-3">
        <div className="text-blue-900 my-1">
          Branch<span className="text-red-700 font-bold">*</span>:
        </div>
        <Select
          value={branch}
          onChange={(selected) => changeBranch(selected)}
          options={branchOptions}
          className="min-w-0 flex-grow text-left text-blue-800"
          placeholder="Choose branch..."
          isClearable={true}
          styles={customSelectStyles}
          menuPortalTarget={document.body}
        />
      </div>
      <div className="mt-7 mb-2 text-blue-900 text-lg">
        Copy from<span className="text-red-700 font-bold">*</span>:
      </div>
      <div className="inline-block mx-3">
        <div className="my-1">Agent:</div>
        <div
          data-tooltip-id="my-tooltip-agent"
          data-tooltip-content={!branch ? 'Need to select branch first' : null}
        >
          <Select
            isDisabled={!branch}
            value={agentFrom}
            onChange={async (selected) => {
              setAgentFrom(selected);
              if (agentTo) {
                await checkRates(
                  branch?.value,
                  selected?.value,
                  agentTo?.value,
                );
              }
            }}
            options={agentsForSearch?.filter(
              (item) => item.value !== agentTo?.value,
            )}
            className="min-w-0 flex-grow text-left text-blue-800"
            placeholder="Choose agent..."
            isClearable={true}
            styles={customSelectStyles}
            menuPortalTarget={document.body}
          />
        </div>
        <Tooltip id="my-tooltip-agent" />
      </div>
      <div className="mt-7 mb-2 text-blue-900 text-lg">
        Copy to<span className="text-red-700 font-bold">*</span>:
      </div>
      <div className="inline-block mx-3">
        <div className="my-1">Agent:</div>
        <div
          data-tooltip-id="my-tooltip-agent"
          data-tooltip-content={!branch ? 'Need to select branch first' : null}
        >
          <Select
            isDisabled={!branch}
            value={agentTo}
            onChange={async (selected) => {
              setAgentTo(selected);
              if (agentFrom) {
                await checkRates(
                  branch?.value,
                  agentFrom?.value,
                  selected?.value,
                );
              }
            }}
            options={agentsForSearch?.filter(
              (item) => item.value !== agentFrom?.value,
            )}
            className="min-w-0 flex-grow text-left text-blue-800"
            placeholder="Choose agent..."
            isClearable={true}
            styles={customSelectStyles}
            menuPortalTarget={document.body}
          />
        </div>
        <Tooltip id="my-tooltip-agent" />
      </div>
      <div
        className={classNames(
          'min-h-16 my-2',
          showWarning() ? 'block' : 'invisible',
        )}
      >
        {messageLoading ? (
          <div className="flex justify-center pt-7">
            <img className="w-5 h-5" src={loadingGif} />
          </div>
        ) : (
          <>
            {displayMessageType(messageType)}
            <div
              className={classNames(
                'font-normal',
                getMessageColor(messageType),
              )}
            >
              {message}
            </div>
          </>
        )}
      </div>
      <div className="flex flex-row">
        <div
          onClick={() => Swal.close()}
          className="bg-gray-300 px-3 py-2 rounded-md cursor-pointer"
        >
          Cancel
        </div>
        <div
          onClick={() =>
            copyRates(branch?.value, agentFrom?.value, agentTo?.value)
          }
          className={classNames(
            'ml-auto text-white px-3 py-2 rounded-md',
            saveable() && !messageLoading && availableRatesAmount > 0
              ? 'bg-blue-900 cursor-pointer'
              : 'bg-gray-400',
            copyingLoading && 'bg-transparent',
          )}
        >
          {copyingLoading ? (
            <img src={loadingGif} className="w-5 h-5 mx-[7.5px]" />
          ) : (
            'Copy'
          )}
        </div>
      </div>
    </div>
  );
};

export default ParcelRatesCreatingWindow;
